import { get, ref } from "firebase/database";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { database } from "../firebase";

const Login = () => {
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword]     = useState("");
  const [showPass, setShowPass]     = useState(false);
  const [error, setError]           = useState("");
  const [loading, setLoading]       = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      const snapshot = await get(ref(database, "admins"));
      let matched = false;
      snapshot.forEach((child) => {
        const user = child.val();
        if ((user.email === identifier || user.mobile === identifier) && user.password === password) {
          matched = true;
          localStorage.setItem("adminName", user.name);
        }
      });
      if (matched) { navigate("/admin"); }
      else { setError("Invalid credentials. Please try again."); }
    } catch {
      setError("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <style>{`
        .login-page {
          min-height: 100vh;
          background: linear-gradient(135deg, #f8fdf0 0%, #fffbe5 100%);
          display: flex;
          align-items: center;
          padding: 40px 16px;
        }
        .login-card {
          width: 100%;
          max-width: 900px;
          margin: 0 auto;
          border-radius: 20px;
          overflow: hidden;
          box-shadow: 0 16px 56px rgba(77,61,108,0.13);
          display: flex;
          animation: loginFadeUp 0.6s ease both;
        }
        @keyframes loginFadeUp {
          from { opacity: 0; transform: translateY(36px); }
          to   { opacity: 1; transform: translateY(0); }
        }

        /* ── Left panel ── */
        .login-left {
          flex: 1;
          background: linear-gradient(160deg, #4d3d6c 0%, #7b5ea7 100%);
          padding: 40px 36px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          color: #fff;
        }
        .login-left h2 { font-size: 1.5rem; font-weight: 700; line-height: 1.35; }
        .login-left p  { font-size: 13px; opacity: 0.82; margin-top: 8px; }
        .login-img-wrap {
          flex: 1;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 16px 0;
        }
        .login-img-wrap img {
          max-width: 100%;
          max-height: 260px;
          object-fit: contain;
          filter: drop-shadow(0 8px 24px rgba(0,0,0,0.18));
          animation: floatImg 4s ease-in-out infinite;
        }
        @keyframes floatImg {
          0%, 100% { transform: translateY(0); }
          50%       { transform: translateY(-10px); }
        }
        .login-iso {
          font-size: 12px;
          opacity: 0.7;
          margin-top: 16px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        /* ── Right panel ── */
        .login-right {
          flex: 1;
          background: #fff;
          padding: 52px 44px;
          display: flex;
          flex-direction: column;
          justify-content: center;
        }
        .login-right .form-control {
          border-radius: 10px;
          border: 1.5px solid #e0e0e0;
          font-size: 14px;
          padding: 11px 14px;
          transition: border-color 0.2s, box-shadow 0.2s;
        }
        .login-right .form-control:focus {
          border-color: #90b732;
          box-shadow: 0 0 0 3px rgba(144,183,50,0.15);
        }
        .login-right label { font-size: 13px; font-weight: 600; color: #444; margin-bottom: 5px; }
        .input-icon-wrap { position: relative; }
        .input-icon-wrap .input-icon {
          position: absolute; left: 13px; top: 50%; transform: translateY(-50%);
          color: #aaa; font-size: 15px; pointer-events: none;
        }
        .input-icon-wrap .form-control { padding-left: 38px; }
        .input-icon-wrap .toggle-pass {
          position: absolute; right: 13px; top: 50%; transform: translateY(-50%);
          color: #aaa; cursor: pointer; font-size: 15px;
          transition: color 0.2s;
        }
        .input-icon-wrap .toggle-pass:hover { color: #4d3d6c; }
        .btn-login {
          background: linear-gradient(90deg, #90b732, #6fa020);
          color: #fff; border: none;
          border-radius: 10px;
          padding: 12px 0;
          font-size: 15px; font-weight: 600;
          width: 100%;
          transition: transform 0.2s, box-shadow 0.2s;
          margin-top: 4px;
        }
        .btn-login:hover:not(:disabled) {
          transform: translateY(-2px);
          box-shadow: 0 6px 20px rgba(144,183,50,0.35);
        }
        .btn-login:disabled { opacity: 0.7; }
        .divider {
          display: flex; align-items: center; gap: 12px;
          color: #ccc; font-size: 12px; margin: 20px 0;
        }
        .divider::before, .divider::after {
          content: ''; flex: 1; height: 1px; background: #eee;
        }

        @media (max-width: 767px) {
          .login-left  { display: none; }
          .login-right { padding: 36px 24px; }
          .login-card  { border-radius: 16px; }
        }
      `}</style>

      <div className="login-page">
        <div className="login-card">

          {/* ── Left Panel ── */}
          <div className="login-left">
            <div>
              <img
                src={`${process.env.PUBLIC_URL}/tally.png`}
                alt="logo"
                style={{ height: 40, marginBottom: 20, filter: 'brightness(0) invert(1)' }}
              />
              <h2>Welcome Back to Shrikant Tally Institute</h2>
              <p>Sign in to access your admin dashboard and manage students, batches, and more.</p>
            </div>

            <div className="login-img-wrap">
              <img
                src={`${process.env.PUBLIC_URL}/leftimg.webp`}
                alt="Login Banner"
              />
            </div>

            <div className="login-iso">
              <span>🏅</span> ISO 9001:2015 Certified · Damoh, MP
            </div>
          </div>

          {/* ── Right Panel ── */}
          <div className="login-right">
            <div className="mb-4">
              <h4 className="fw-bold mb-1" style={{ color: '#4d3d6c' }}>Admin Login</h4>
              <p className="text-muted" style={{ fontSize: 13 }}>
                <i className="bi bi-shield-lock me-1"></i>Restricted to authorized staff only
              </p>
            </div>

            {error && (
              <div className="alert alert-danger d-flex align-items-center gap-2 py-2 mb-3" style={{ fontSize: 13, borderRadius: 10 }}>
                <i className="bi bi-exclamation-circle-fill"></i> {error}
              </div>
            )}

            <form onSubmit={handleLogin}>
              <div className="mb-3">
                <label>Email or Mobile</label>
                <div className="input-icon-wrap">
                  <i className="bi bi-person input-icon"></i>
                  <input
                    type="text"
                    className="form-control"
                    value={identifier}
                    onChange={e => setIdentifier(e.target.value)}
                    placeholder="Enter email or mobile"
                    required
                  />
                </div>
              </div>

              <div className="mb-4">
                <label>Password</label>
                <div className="input-icon-wrap">
                  <i className="bi bi-lock input-icon"></i>
                  <input
                    type={showPass ? "text" : "password"}
                    className="form-control"
                    value={password}
                    onChange={e => setPassword(e.target.value)}
                    placeholder="Enter password"
                    required
                  />
                  <i
                    className={`bi ${showPass ? 'bi-eye-slash' : 'bi-eye'} toggle-pass`}
                    onClick={() => setShowPass(p => !p)}
                  ></i>
                </div>
              </div>

              <button type="submit" className="btn-login" disabled={loading}>
                {loading
                  ? <><span className="spinner-border spinner-border-sm me-2"></span>Signing in...</>
                  : <><i className="bi bi-box-arrow-in-right me-2"></i>Sign In</>
                }
              </button>
            </form>

            <div className="divider">secure login</div>

            <p className="text-center text-muted mb-0" style={{ fontSize: 12 }}>
              <i className="bi bi-lock-fill me-1 text-success"></i>
              Your session is protected. All data is encrypted.
            </p>
          </div>

        </div>
      </div>
    </>
  );
};

export default Login;
